module.exports = require('../lib/linkify/plugins/hashtag').default;



// WEBPACK FOOTER //
// ../node_modules/linkifyjs/plugins/hashtag.js